export default __webpack_public_path__ + "static/media/big-cross.c9ffd04e.svg";